import { NgModule } from '@angular/core';
import { defaultOccAsmConfig } from '@asm/const';
import { AsmDataAccessModule } from '@asm/data-access';
import { AsmFeatureModule } from '@asm/feature';
import { AsmUiModule } from '@sdvor/asm/ui';
import { provideDefaultConfig } from '@spartacus/core';

@NgModule({
  imports: [AsmFeatureModule, AsmUiModule, AsmDataAccessModule],
  providers: [provideDefaultConfig(defaultOccAsmConfig)],
})
export class SdvorAsmShellModule {}
